"use client";
import { useState } from "react";
import VideoList from "./VideoList";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";

interface Tab {
  id: number;
  tab: string;
  label: string;
}

const VideoTabs = () => {
  const [activeTab, setActiveTab] = useState<string>("gettingStarted");
  const [searchTerm, setSearchTerm] = useState<string>("");

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    setSearchTerm("");
  };

  const videoTabs: Tab[] = [
    { id: 1, tab: "gettingStarted", label: "Getting Started" },
    { id: 2, tab: "krooloAi", label: "Kroolo AI" },
    { id: 3, tab: "goals", label: "Goal & OKRs" },
    { id: 4, tab: "projects", label: "Projects & Sprints" },
    { id: 5, tab: "tasks", label: "Tasks" },
    { id: 6, tab: "chat", label: "Chat" },
    { id: 7, tab: "docs", label: "Docs" },
    { id: 8, tab: "teams", label: "Teams" },
    { id: 9, tab: "integrations", label: "Integrations" },
    { id: 10, tab: "automations", label: "Automations" },
  ];

  return (
    <div className="mx-auto max-w-screen-2xl py-12">
      <div className="mb-10 flex flex-col gap-10 xlg:flex-row">
        <div className="z-20 w-full flex-initial xlg:sticky xlg:top-[4.4rem] xlg:w-[18%]">
          <div className="sticky top-28">
            <div className="rounded-[8px]">
              <div className="h-full space-y-2 rounded-[8px] bg-white text-sm font-medium text-gray-500 xlg:space-y-4">
                <h3 className="mb-2 text-[18px] font-semibold text-[#202020] xlg:mb-4 xl:text-[22px]">
                  Categories
                </h3>
                <div className="xlg:hidden">
                  <Select
                    onValueChange={handleTabChange}
                    defaultValue="gettingStarted"
                  >
                    <SelectTrigger className="gradientBgBtn w-full px-3 py-2 text-[#202020]">
                      <SelectValue placeholder="Choose a category" />
                    </SelectTrigger>
                    <SelectContent className="bg-[#F2F2F2] text-[#202020]">
                      {videoTabs.map((tabItem) => (
                        <SelectItem
                          key={tabItem.id}
                          value={tabItem.tab}
                          className="opacity-80 hover:bg-[#c8c8c8] hover:opacity-100"
                        >
                          {tabItem.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <ul className="hidden xlg:block">
                  {videoTabs.map((tabItem) => (
                    <li key={tabItem.id} className="rounded">
                      <button
                        onClick={() => handleTabChange(tabItem.tab)}
                        className={`w-full rounded-[8px] p-1 text-left text-[12px] font-normal sm:text-[14px] lg:px-2.5 lg:py-2.5 xl:text-[16px] ${activeTab === tabItem.tab
                          ? "border-[#202020] bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent"
                          : "border-[#E0E0EA] bg-white text-[#4A4A4A] hover:border-[#C5C5D8]"
                          }`}
                      >
                        {tabItem.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex-initial xlg:w-[75%]">
          <VideoList
            key={activeTab}
            activeTab={activeTab}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        </div>
      </div>
    </div>
  );
};

export default VideoTabs;
